import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useHistory } from "react-router-dom";
import { auth } from "../../../firebase/config";

export const SideBar = () => {

    const navigate = useHistory();

    const [user] = useAuthState(auth);

    const handleSignOut = () => {
        signOut(auth)
        localStorage.clear()
        navigate.push("/login")
    }

    return (
        <>

            <div class="p-4 pt-5">
                <div class="dash-user-detail">
                    <h4 class="text-light"> Hello! Admin</h4>
                    {user && (
                        <p class="admin-subt">{user.email}</p>
                    )}
                </div>

                <ul class="list-unstyled components mb-5">
                    <li class="active">
                        <a href="/admin/dashboard">Dashboard</a>
                    </li>
                    <li>
                        <button type="button" className="dropdown-toggle" data-toggle="collapse" data-target="#homeSubmenu" aria-expanded="false" style={{background: 'none', border: 'none', padding: 0, color: 'inherit', cursor: 'pointer'}}>
                            Reviews
                        </button>
                        <ul class="collapse list-unstyled" id="homeSubmenu">
                            <li>
                                <a href="/admin/list-reviews">List all Reviews</a>
                            </li>
                            <li>
                                <a href="/admin/create-review">Add Review</a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="/admin/services">Services</a>
                    </li>
                    <li>
                        <a href="/admin/gallery">Gallery/Images</a>
                    </li>
                    <li>
                        <a href="/admin/contact">Contact Info</a>
                    </li>
                    {/* <li>
                        <button type="button" className="dropdown-toggle" aria-expanded={openAlbumMenu} style={{background: 'none', border: 'none', padding: 0, color: 'inherit', cursor: 'pointer'}}>
                            Album
                        </button>
                        {openAlbumMenu ? (
                            <ul class="collapse list-unstyled show" id="homeSubmenu">
                                <li>
                                    <a href="/list-album">List all albums</a>
                                </li>
                                <li>
                                    <a href="/create-album">Add album</a>
                                </li>
                            </ul>
                        ) : null}
                    </li> */}
                    {/* <li>
                        <button type="button" className="dropdown-toggle" aria-expanded={openNewsMenu} style={{background: 'none', border: 'none', padding: 0, color: 'inherit', cursor: 'pointer'}}>
                            News
                        </button>
                        {openNewsMenu ? (
                            <ul class="collapse list-unstyled show" id="homeSubmenu">
                                <li>
                                    <a href="/list-news">List all News</a>
                                </li>
                                <li>
                                    <a href="/create-news">Add News</a>
                                </li>
                            </ul>
                        ) : null}

                    </li> */}

                    {/* <li>
                        <a href="#" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle ">Songs</a>
                        {openSongMenu ? (
                            <ul class="collapse list-unstyled show" id="homeSubmenu">
                                <li>
                                    <a href="/list-songs">List all Songs</a>
                                </li>
                                <li>
                                    <a href="/create-song">Add Song</a>
                                </li>
                            </ul>
                        ) : null}

                    </li> */}
                    <li>
                        <button type="button" onClick={handleSignOut} style={{background: 'none', border: 'none', padding: 0, color: 'inherit', cursor: 'pointer'}}>Log out</button>
                    </li>
                </ul>

                {/* <div class="footer fixed-bottom">
                    Copyright &copy;<script>document.write(new Date().getFullYear());</script> Developed <i class="icon-heart" aria-hidden="true"></i> by <a href="https://infocliq.net" target="_blank">infocliq</a>
                </div> */}

            </div>

        </>
    )
}
